import React, { useEffect, useRef } from "react";
import Image from "next/image";
import useEmblaCarousel from "embla-carousel-react";
import Autoplay from "embla-carousel-autoplay";

const Universities: React.FC = () => {
  const [emblaRef1, emblaApi1] = useEmblaCarousel(
    {
      loop: true,
      dragFree: true,
      containScroll: "trimSnaps",
      skipSnaps: false,
      align: "start",
    },
    [],
  );

  useEffect(() => {
    if (emblaApi1) {
      let interval: ReturnType<typeof setInterval>;

      const startReverseAutoplay = () => {
        interval = setInterval(() => {
          if (emblaApi1) {
            emblaApi1.scrollPrev();
          }
        }, 2000);
      };

      const stopReverseAutoplay = () => {
        if (interval) clearInterval(interval);
      };

      startReverseAutoplay();

      const emblaNode = emblaApi1.containerNode();
      if (emblaNode) {
        emblaNode.addEventListener("mouseenter", stopReverseAutoplay);
        emblaNode.addEventListener("mouseleave", startReverseAutoplay);
      }

      return () => {
        stopReverseAutoplay();
        if (emblaNode) {
          emblaNode.removeEventListener("mouseenter", stopReverseAutoplay);
          emblaNode.removeEventListener("mouseleave", startReverseAutoplay);
        }
      };
    }
  }, [emblaApi1]);

  const autoplayRef2 = useRef(
    Autoplay({
      delay: 2000,
      stopOnInteraction: false,
      stopOnMouseEnter: true,
    }),
  );

  const [emblaRef2, emblaApi2] = useEmblaCarousel(
    {
      loop: true,
      dragFree: true,
      containScroll: "trimSnaps",
    },
    [autoplayRef2.current],
  );

  useEffect(() => {
    if (emblaApi2 && autoplayRef2.current) {
      autoplayRef2.current.play();
    }
  }, [emblaApi2]);
  const universityLogos = [
    { src: "/accounting/ds.svg", alt: "MBE", width: 48, height: 24 },
    {
      src: "/images/accounting/usp/MSUMob.svg",
      alt: "MBE",
      width: 98,
      height: 24,
    },
    {
      src: "/images/accounting/usp/RutUni.svg",
      alt: "MBE",
      width: 98,
      height: 24,
    },
    {
      src: "/images/accounting/usp/DEU.svg",
      alt: "MBE",
      width: 54,
      height: 20,
    },
    {
      src: "/images/accounting/usp/TUMOB.svg",
      alt: "MBE",
      width: 98,
      height: 24,
    },
    {
      src: "/images/accounting/usp/RITMOB.svg",
      alt: "MBE",
      width: 46,
      height: 14,
    },
    {
      src: "/images/accounting/usp/UoDMOB.svg",
      alt: "MBE",
      width: 66,
      height: 24,
    },
    {
      src: "/images/accounting/usp/DU.svg",
      alt: "MBE",
      width: 58,
      height: 24,
    },
    {
      src: "/images/accounting/usp/RU.svg",
      alt: "MBE",
      width: 98,
      height: 24,
    },
    {
      src: "/images/accounting/usp/PUMOB.svg",
      alt: "MBE",
      width: 58,
      height: 24,
    },
    {
      src: "/images/accounting/usp/ASU.svg",
      alt: "MBE",
      width: 54,
      height: 24,
    },
    {
      src: "/images/accounting/usp/CU.svg",
      alt: "MBE",
      width: 98,
      height: 24,
    },
    {
      src: "/images/accounting/usp/ISU.svg",
      alt: "MBE",
      width: 56,
      height: 24,
    },
    {
      src: "/images/accounting/usp/NIU.svg",
      alt: "MBE",
      width: 98,
      height: 24,
    },
  ];

  const companyLogos = [
    {
      src: "/images/accounting/usp/SDK.svg",
      alt: "MBE",
      width: 56,
      height: 24,
    },
    {
      src: "/images/accounting/usp/Williams.svg",
      alt: "MBE",
      width: 60,
      height: 14,
    },
    {
      src: "/images/accounting/usp/rsmMob.svg",
      alt: "MBE",
      width: 60,
      height: 20,
    },
    {
      src: "/images/accounting/usp/MBE_mob.svg",
      alt: "MBE",
      width: 58,
      height: 18,
    },
    {
      src: "/images/accounting/usp/hancock.svg",
      alt: "MBE",
      width: 106,
      height: 24,
    },
    { src: "/accounting/smitt.svg", alt: "MBE", width: 78, height: 24 },
    { src: "/accounting/smi.svg", alt: "MBE", width: 112, height: 24 },
    { src: "/accounting/caps.svg", alt: "MBE", width: 104, height: 24 },
    {
      src: "/images/accounting/usp/BDOmob.svg",
      alt: "MBE",
      width: 48,
      height: 18,
    },
  ];

  // Duplicate arrays for seamless infinite scroll
  const universityLogosDuplicated = [
    ...universityLogos,
    ...universityLogos,
    ...universityLogos,
  ];
  const companyLogosDuplicated = [
    ...companyLogos,
    ...companyLogos,
    ...companyLogos,
  ];

  return (
    <>
      <div className="w-full md:pt-[60px] pt-[30px] md:pb-[80px] pb-[70px] bg-[#0C1F33] relative z-[9]">
        <Image
          src="/images/accounting/usp/Payment-mount.png"
          alt="Special Offer"
          className="mx-auto absolute md:bottom-0 bottom-0 left-0 w-full z-[-1]"
          width={360}
          height={327}
          priority
        />
        <div className="lg:container mx-auto 2xl:px-0 xl:px-10 lg:p-0">
          <div className="text-center">
            <h2 className="font-semibold md:text-[36px] text-[20px]  text-[#fff] text-center mb-6 leading-6">
              What is the US Pathway
              <br /> for
              <span className="border-[#ca7216] border-b-2 inline-block ml-[5px]">
                Accountants?
              </span>
            </h2>
          </div>

          <div className="w-[340px] mx-auto">
            <div className="relative">
              <Image
                src="/images/accounting/usp/yellow.svg"
                alt="universities"
                className="w-[340px] mx-auto"
                width={328}
                height={170}
                priority
              />
              <div className="flex items-center justify-start absolute top-0 left-0 w-full h-full">
                <div className="w-[50%] flex flex-col items-center justify-center text-center">
                  <p className="text-[#3B3B3B] text-[22px] font-bold tracking-[0.66px] leading-6">
                    1 year of <br /> Study
                  </p>
                  <p className="w-[50%] bg-[#FFBA08] text-black text-[10px] font-bold mt-2">
                    STEM-designated
                  </p>
                </div>

                <div className="w-[28%] text-center overflow-hidden">
                  <p className="text-center text-[10px] text-[#A05200] font-medium pb-6 tracking-[-0.3px] leading-normal">
                    Master's from top University in the US
                  </p>
                  <div className="">
                    <div
                      className="embla overflow-hidden w-full"
                      ref={emblaRef1}
                    >
                      <div
                        className="embla__container flex"
                        style={{
                          backfaceVisibility: "hidden",
                          transform: "translate3d(0, 0, 0)",
                        }}
                      >
                        {universityLogosDuplicated.map((logo, index) => (
                          <div
                            key={`university-${index}`}
                            className="embla__slide flex-[0_0_auto] flex-shrink-0 flex items-center justify-center"
                            style={{
                              minWidth: "60px",
                              marginRight: "10px",
                            }}
                          >
                            <Image
                              src={logo.src}
                              alt={logo.alt}
                              className="mx-auto"
                              width={logo.width}
                              height={logo.height}
                            />
                          </div>
                        ))}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="relative">
              <Image
                src="/images/accounting/usp/blue.svg"
                alt="companies"
                className="w-[340px] mx-auto"
                width={328}
                height={170}
                priority
              />
              <div className="flex items-center justify-end absolute top-0 left-0 h-full w-full">
                <div className="w-[28%] text-center">
                  <p className="text-center text-[10px] text-[#00478E] font-medium pb-5 tracking-[-0.3px] leading-normal">
                    Jobs at CPA firms <br /> in the US
                  </p>
                  <div className="">
                    <div
                      className="embla overflow-hidden w-full"
                      ref={emblaRef2}
                    >
                      <div
                        className="embla__container flex"
                        style={{
                          backfaceVisibility: "hidden",
                          transform: "translate3d(0, 0, 0)",
                        }}
                      >
                        {companyLogosDuplicated.map((logo, index) => (
                          <div
                            key={`company-${index}`}
                            className="embla__slide flex-[0_0_auto] flex-shrink-0 flex items-center justify-center"
                            style={{
                              minWidth: "60px",
                              marginRight: "10px",
                            }}
                          >
                            <Image
                              src={logo.src}
                              alt={logo.alt}
                              className="mx-auto"
                              width={logo.width}
                              height={logo.height}
                            />
                          </div>
                        ))}
                      </div>
                    </div>
                  </div>
                </div>
                <div className="w-[50%] flex flex-col items-center justify-center text-center overflow-hidden">
                  <p className="text-[#3B3B3B] text-[22px] font-bold tracking-[0.66px] leading-6">
                    3 years of <br /> Work
                  </p>
                  <p className="text-[#555555] text-[9px] font-bold">
                    Starting Salary
                  </p>
                  <p className="w-[60%] bg-[#FFBA08] text-black text-[10px] font-bold">
                    $60,000+ (₹50+ lakhs)
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
export default Universities;
